import { createRoot } from 'react-dom/client'
import { useState, useEffect, useRef } from 'react'
import './styles.css'
import App from './App'

const messages = [
  'lucca. come outside.',
  'its been weeks and my brain is still running ur face in a loop',
  'i wrote u a whole website bc texting felt too small',
  'u broke my focus and i build companies for a living',
  'come over. ill cook something mid and pretend its good',
  'i miss u in a way that would be embarrassing to explain out loud',
  'ur literally the reason i check my phone like an addict',
  'i have mass opinions about everything except when u talk then i just listen',
  'come back so i can be annoying in person again',
  'i want u next to me doing nothing. thats the whole ask',
  'im not above begging at this point just so u know',
]

function Typewriter({ text }) {
  const [displayed, setDisplayed] = useState('')
  const idx = useRef(0)

  useEffect(() => {
    setDisplayed('')
    idx.current = 0
    const interval = setInterval(() => {
      if (idx.current < text.length) {
        setDisplayed(text.slice(0, idx.current + 1))
        idx.current++
      } else {
        clearInterval(interval)
      }
    }, 45)
    return () => clearInterval(interval)
  }, [text])

  return (
    <>
      {displayed}
      <span className="cursor">|</span>
    </>
  )
}

function Overlay() {
  const [current, setCurrent] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((c) => (c + 1) % messages.length)
    }, 5000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="overlay">
      <div className="overlay-top-left">for lucca</div>
      <div className="overlay-center" key={current}>
        <Typewriter text={messages[current]} />
      </div>
      <div className="overlay-bottom-right">from jan</div>
    </div>
  )
}

createRoot(document.getElementById('root')).render(
  <>
    <App />
    <Overlay />
  </>
)
